import { useField, useFormikContext } from 'formik';

import { MoneyInput } from './MoneyInput';
import type { MoneyInputProps } from './MoneyInput';

interface FormikMoneyInputProps extends MoneyInputProps {
    name: string;
}

export const FormikMoneyInput = (props: FormikMoneyInputProps) => {
    const [field, meta, helpers] = useField(props.name);
    const { validateOnChange } = useFormikContext();

    const handleOnValueChange = (value?: string) => {
        helpers.setValue(value ?? '');
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <MoneyInput
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error && typeof meta.error === 'string' ? meta.error : props.caption}
            onValueChange={handleOnValueChange}
            {...props}
            name={field.name}
            value={field.value}
            onBlur={field.onBlur}
        />
    );
};
